import styled from 'styled-components';
import { COLORS } from '../../constants/style/color';
import { getViewHeight, rem } from '../../utils/style';
import Heading from '../typography';

interface OuterNavbarContainerType {
  hasNotify?: boolean;
  isSwitched?: boolean;
}

export const OuterNavbarContainer = styled.div<OuterNavbarContainerType>`
  height: 67px;
  box-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  position: sticky;
  top: ${(props) => (props.hasNotify ?? false ? '34px' : '0px')};
  z-index: 998;
  background: ${COLORS.White};
  position: fixed;
  width: 100vw;
`;

export const NavMenuContainer = styled.div`
  display: none;
  justify-content: center;
  align-items: center;
  gap: 10px;

  .navMenuItem {
    height: 67px;
    position: relative;
  }

  @media (min-width: 992px) {
    display: flex;
    gap: 2px;
  }

  @media (min-width: 1200px) {
    font-size: ${rem(15)};
    gap: 10px;
  }
`;

export const NavMenuCon = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  pointer-events: auto;
  cursor: pointer;
  margin: 0 5px;

  > a {
    font-weight: 400;
    font-size: ${rem(16)};
    line-height: ${rem(22)};
    color: ${COLORS.Black};
    display: inline-flex;
    align-items: center;
    transition: all 0.2s linear;
    cursor: pointer;
    height: 100%;
    position: relative;

    &:hover {
      &:after {
        content: '';
        height: 3px;
        width: 100%;
        background: ${COLORS.Purple};
        position: absolute;
        left: 0;
        bottom: 0;
        transition: all 0.2s linear;
      }
    }

    &:after {
      content: '';
      height: 3px;
      width: 0;
      background: ${COLORS.Purple};
      position: absolute;
      left: 0;
      bottom: 0;
      transition: all 0.2s linear;
    }

    &.active {
      color: ${COLORS.Purple};
      &:after {
        content: '';
        width: 100%;
      }
    }

    @media (min-width: 1500px) {
      font-size: ${rem(16)};
    }
  }
  .submenu {
    opacity: 0;
    visibility: hidden;
    transform: translateY(-10px);
    transition: opacity 0.3s ease, visibility 0.3s ease, transform 0.3s ease;
    pointer-events: none;
  }
  :hover {
    .submenu {
      opacity: 1;
      visibility: visible;
      transform: translateY(0);
      pointer-events: auto;
    }
  }
`;

// Profile Dropdown
export const ProfileDropdownContainer = styled.div`
  gap: 7px;
  display: none;
  align-items: center;
  font-size: 15px;
  color: ${COLORS.Gray60};
  width: auto;
  height: 100%;

  .bellIcon {
    font-size: 34px;
    color: ${COLORS.SpanishGray};
  }
  span {
    cursor: pointer;
  }

  .title {
    display: block;
    font-weight: 500;
    font-size: 8px;
    line-height: 22px;
    padding: 12px 12px;

    color: ${COLORS.Black};

    @media (min-width: 768px) {
      font-size: 9px;
    }

    @media (min-width: 992px) {
      font-size: 16px;
    }
  }

  // @media (min-width: 768px) {
  //   display: flex;
  // }

  @media (min-width: 992px) {
    display: flex;
  }

  .profile-dropdown {
    margin-left: 4px;
    color: ${COLORS.Blue};
  }
`;

export const ProfileDropWrapper = styled.div`
  position: relative;
`;

export const ProfileDrop = styled.div`
  display: flex;
  height: 100%;
  justify-content: flex-start;
  align-items: center;
  cursor: pointer;
  flex-grow: 1;
  border: 1px solid ${COLORS.LightGray};
  border-radius: 6px;

  .downIcon {
    color: ${COLORS.Gray};
    margin-right: 7px;
    margin-top: 5px;
  }
`;

export const ProfileDropdownMenu = styled.div`
  position: absolute;
  display: flex;
  flex-direction: column;
  width: 245px;
  right: 0;
  top: 64px;
  z-index: 2000;
  background: ${COLORS.White};

  box-shadow: 0px 2px 20px ${COLORS.SoftShadow};
  border-radius: 11px;
  padding: 10px 13px;

  &.nav-subMenu {
    left: 0;
    top: 73px;
    right: reset;
    justify-content: flex-start;

    a {
      width: 100%;
      justify-content: flex-start;
      color: ${COLORS.SpanishGray};
      font-size: ${rem(14)};
    }
  }
`;

export const DropDownMenuSuperAdmin = styled.div`
  color: ${COLORS.Black};
  display: flex;
  align-items: center;
  justify-content: flex-start;
  font-weight: 400;
  border-radius: 4px;
  padding: 10px 14px;
  transition: all 0.2s linear;
  cursor: pointer;
  font-size: 1.4rem;
  line-height: 1.8rem;

  &.logoutBtn {
    color: ${COLORS.SpanishGray};
  }

  :hover {
    background: ${COLORS.LightPurple};
    color: ${COLORS.Purple};
    font-weight: 500;
  }
`;

// Task Menu
export const TaskSubMenuDropDown = styled.div`
  z-index: 100;
  position: absolute;
  padding: 4px;
  top: 64px;
  background: rgba(255, 255, 255, 0.98);
  box-shadow: 0px 2px 20px ${COLORS.SoftShadow};
  border-radius: 5px;
  text-align: left;
  right: 0;

  span {
    font-size: 12px;
  }
`;

export const DropDownMenuAdmin = styled.div`
  display: flex;
  align-items: center;
  color: ${COLORS.Purple};
  cursor: pointer;
  border-bottom: 0.5px solid ${COLORS.Gray80};

  a {
    font-size: 12px;
    white-space: nowrap;

    color: ${COLORS.Black};
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 400;
    border-radius: 4px;
    padding: 10px 14px;
    transition: all 0.2s linear;
    cursor: pointer;
    &.logoutBtn {
      color: ${COLORS.SpanishGray};
    }
    :hover {
      background: ${COLORS.LightPurple};
      color: ${COLORS.Purple};
      font-weight: 500;
    }
  }

  &:last-child {
    border-bottom: none;
  }
`;

export const HeaderNotice = styled.div`
  background-color: ${COLORS.CulturedWhite};
  padding: ${rem(0)} ${rem(20)};
  min-height: 34px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-right: ${rem(48)};
  position: fixed;
  z-index: 998;
  width: 100%;
  top: 0;
  transition: all 0.2s linear;

  .closeIcon {
    color: ${COLORS.SpanishGray};
    position: absolute;
    top: 50%;
    right: 24px;
    transform: translateY(-50%);
    cursor: pointer;
  }

  @media (max-width: 512px) {
    .notice-header {
      font-size: ${rem(12)};
      line-height: ${rem(14)};
    }
  }
`;

// new navbar design
export const NavbarContainerMain = styled.nav<OuterNavbarContainerType & { isMenuOpen?: boolean }>`
  height: 67px;
  box-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  position: sticky;
  top: ${(props) => (props.hasNotify ?? false ? '34px' : '0px')};
  z-index: 1001;
  background: ${(props) => (props?.isSwitched ? COLORS?.CornSilk : COLORS?.White)};
  position: fixed;
  width: 100vw;
  padding: ${rem(0)} ${rem(20)};

  display: flex;
  align-items: center;
  justify-content: space-between;

  .nav {
    &-brand {
      width: min(191px, 90%);
    }

    &-mobile {
      display: flex;

      @media (min-width: 992px) {
        display: none;
      }

      .nav-menu {
        border-radius: 30px;
        padding: ${rem(7)} ${rem(12)};

        span {
          padding-right: ${rem(7)};
          font-size: ${rem(20)};
        }
      }

      &--heading {
        color: rgb(119 119 119 / 60%);
        text-transform: uppercase;
        font-weight: 500;
        margin-bottom: ${rem(27)};
        text-align: left;
        align-self: flex-start;
        padding-left: ${rem(16)};
      }

      .nav-close {
        margin-top: ${rem(20)};
      }
      .nav-close-top-right {
        position: absolute;
        top: ${rem(20)};
        right: ${rem(20)};
        margin-top: ${rem(0)};

        .nav-mobile--close {
          border-radius: 30px;
          border: none;
          padding: ${rem(12)} ${rem(12)};

          font-weight: 400;
          font-size: ${rem(14)};
          line-height: ${rem(18)};

          span {
            font-size: ${rem(14)};
          }
        }
      }

      &--close {
        border-radius: 30px;
        border: none;
        padding: ${rem(16)} ${rem(24)};

        font-weight: 400;
        font-size: ${rem(14)};
        line-height: ${rem(18)};

        span {
          padding-right: ${rem(7)};
          font-size: ${rem(12)};
        }
      }
    }
  }
`;

export const MobileMenuBackdrop = styled.div<{ isOpen: boolean; hasNotify?: boolean }>`
  position: fixed;
  // top: 0;
  top: ${(props) => (props.hasNotify ? '101px' : '67px')};

  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.5);
  z-index: 998;
  opacity: ${(props) => (props.isOpen ? 1 : 0)};
  visibility: ${(props) => (props.isOpen ? 'visible' : 'hidden')};
  transition: opacity 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94),
    visibility 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94);

  @media (min-width: 992px) {
    display: none;
  }
`;

// menu mobile container
export const NavMenuMobileContainer = styled.div<{ isOpen: boolean; hasNotify?: boolean }>`
  display: flex;
  flex-direction: column;
  position: fixed;
  width: 280px;
  max-width: 85vw;
  // height: ${(props) => (props.hasNotify ? 'calc(100vh - 101px)' : 'calc(100vh - 67px)')};
  height: 100vh;
  background: ${COLORS.OffWhite};
  transition: transform 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  overflow-y: auto;
  top: ${(props) => (props.hasNotify ? '101px' : '67px')};
  // top:0;
  right: 0;
  z-index: 999;
  transform: ${(props) => (props.isOpen ? 'translateX(0)' : 'translateX(100%)')};
  // box-shadow: ${(props) => (props.isOpen ? '-4px 0 20px rgba(0, 0, 0, 0.15)' : 'none')};

  /* Tablet Portrait and larger phones */
  @media (min-width: 480px) and (max-width: 767px) {
    width: 320px;
  }

  /* Tablet Landscape */
  @media (min-width: 768px) and (max-width: 991px) {
    width: 400px;
  }

  /* Desktop - Hide menu */
  @media (min-width: 992px) {
    display: none;
  }
`;

export const MainContentWrapper = styled.div<{
  isMenuOpen: boolean;
  hasNotify: boolean;
  img?: string;
}>`
  min-height: ${(props) => (props.hasNotify ? `calc(100vh - 101px)` : `calc(100vh - 67px)`)};
  position: relative;

  &:before {
    content: '';
    position: fixed;
    top: ${(props) => (props.hasNotify ? '101px' : '67px')};
    left: 0;
    right: 0;
    bottom: 0;
    z-index: -1;
    background: url(${(props) => props.img}) no-repeat;
    height: ${getViewHeight()};
    background-size: cover;
  }
`;

export const MobileNavItem = styled.div`
  display: flex;
  flex-direction: column;
  text-align: left;
  width: 100%;
  align-items: flex-start;
  padding: ${rem(37)} ${rem(20)};
  border-bottom: 1px solid rgba(215, 215, 215, 50%);
  .disable-bg {
    background: transparent !important;
    span {
      color: ${COLORS.Blue} !important;
    }
  }
  .nav-items {
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    flex-direction: column;
    row-gap: ${rem(22)};
    width: 100%;
    // padding-left: ${rem(16)};

    & a:hover span {
      color: ${COLORS.Purple};
    }
  }
  a {
    font-weight: 600;
    font-size: 15px;
    line-height: 19px;
    color: ${COLORS.Blue};
    display: flex;
    align-items: center;
    cursor: pointer;
  }

  .submenu {
    display: block;
    opacity: 0;
    max-height: 0;
    overflow: hidden;
    transition: opacity 0.3s ease, max-height 0.3s ease;
  }

  &.has-submenu-open .submenu {
    opacity: 1;
    max-height: 300px;
  }

  a.active {
    background: ${COLORS.Purple};
    color: ${COLORS.White};
    // padding-left: 20px;
    // padding-left: 10px !important;
    // padding-right: 10px !important;
    padding: 8px 10px !important;
    width: 100%;
    border-radius: 8px;

    span {
      color: ${COLORS.White};
    }

    @media (min-width: 992px) {
      background: transparent;

      span {
        font-weight: 500;
        color: ${COLORS.Blue};
      }
    }
  }
`;

export const NavBarProfilePic = styled.div<{
  hasImageLogo?: boolean;
}>`
  ${({ hasImageLogo }) => ` max-width: ${rem(hasImageLogo ? 220 : 160)};`}
  display: flex;
  justify-content: center;
  align-items: center;
  height: 50px;
  .nav-switch-label {
    max-width: ${rem(130)};
  }
  img {
    height: ${rem(50)};
    width: 100%;
    max-width: ${rem(65)};
    border-radius: 4px;
    object-fit: contain;
  }
  margin-left: ${rem(15)};
  @media (max-width: 992px) {
    width: 100%;
    max-width: auto;
    justify-content: flex-start;
    margin-left: 0;
    .nav-switch-label {
      max-width: 100%;
      min-width: ${rem(200)};
    }
  }
  @media (min-width: 1800px) {
    max-width: ${rem(200)};
    .nav-switch-label {
      max-width: ${rem(200)};
    }
    img {
      max-width: ${rem(160)};
    }
  }
`;

export const NavBarLabel = styled(Heading)<{
  fontSize?: number;
  lineClamp?: number;
}>`
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  ${({ fontSize }) => fontSize && `font-size: ${rem(fontSize)};`}
  ${({ lineClamp }) => lineClamp && `-webkit-line-clamp: ${lineClamp || 1};`}
`;

export const Spacer = styled.div<{
  height?: number;
  width?: number;
}>`
  ${({ height }) => height && `height: ${rem(height)}`}
  ${({ width }) => width && `width: ${rem(width)}`}
`;

export const InstanceContainer = styled.div`
  // width: ${rem(180)};
  width: auto;
`;

export const MobileSubMenu = styled.div`
  padding-left: ${rem(32)};
  display: flex;
  flex-direction: column;
  row-gap: ${rem(20)};
  opacity: 0;
  max-height: 0;
  overflow: hidden;
  padding-top: 0;
  transition: opacity 0.3s ease, max-height 0.3s ease, padding-top 0.3s ease;

  &.open {
    opacity: 1;
    max-height: 500px;
    padding-top: ${rem(20)};
  }
`;

// Utility class for mobile sub-menu containers
export const mobileSubMenuClass = 'mobile-sub-menu';

// Add to global styles
export const MobileSubMenuStyles = `
  .mobile-sub-menu {
    padding-left: 2rem;
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
  }
`;
